import React from 'react';
import aucunIcon from '../../../img/symbols/aucun.svg';
import triangleIcon from '../../../img/symbols/triangle.svg';
import losangeIcon from '../../../img/symbols/losange.svg';
import octogoneIcon from '../../../img/symbols/octogone.svg';

const HazardSymbol = ({ symbol, size = 32, className = '' }) => {
  if (!symbol || !symbol.label) {
    return null;
  }

  // Map label to icon
  const getSymbolIcon = (label) => {
    const normalizedLabel = label.toLowerCase();

    switch (normalizedLabel) {
      case 'aucun':
        return aucunIcon;
      case 'triangle':
        return triangleIcon;
      case 'losange':
        return losangeIcon;
      case 'octogone':
        return octogoneIcon;
      default:
        return null;
    }
  };

  // Use custom image if provided, otherwise use symbol icon
  const iconSrc = symbol.image || getSymbolIcon(symbol.label);

  if (!iconSrc) {
    // Fallback: just show the label text if no icon is available
    return (
      <span
        className={`inline-flex items-center justify-center border rounded px-2 py-1 text-sm ${className}`}
      >
        {symbol.label}
      </span>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src={iconSrc}
        alt={symbol.label}
        width={size}
        height={size}
        className="flex-shrink-0"
      />
    </div>
  );
};

export default HazardSymbol;
